var map = {
	"./arrow-down-blue.svg": 502,
	"./arrow-down-grey.svg": 503,
	"./arrow-right-white.png": 504,
	"./arrow-right.svg": 505,
	"./blue-loader.svg": 239,
	"./circle-grey.svg": 506,
	"./circle.svg": 507,
	"./coinbaseWalletIcon.svg": 145,
	"./dropdown-blue.svg": 508,
	"./dropdown.svg": 509,
	"./dropup-blue.svg": 510,
	"./ethereum-logo.png": 240,
	"./fortmaticIcon.png": 511,
	"./link.svg": 512,
	"./magnifying-glass.svg": 513,
	"./menu.svg": 514,
	"./metamask.png": 238,
	"./plus-blue.svg": 515,
	"./plus-grey.svg": 516,
	"./portisIcon.png": 517,
	"./question-mark.svg": 518,
	"./question.svg": 519,
	"./spinner.svg": 520,
	"./token-list-logo.png": 521,
	"./token-list/lists-dark.png": 522,
	"./token-list/lists-light.png": 523,
	"./trustWallet.png": 524,
	"./walletConnectIcon.svg": 146,
	"./x.svg": 525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;